<mat-nav-list class="close-button-holder">
  <a mat-icon-button class="button-40 secondary-nav-close" (click)="onCloseSidenav()">
    <mat-icon>close</mat-icon>
  </a>
</mat-nav-list>

<mat-nav-list class="secondary-menu-title" *ngIf="!!currentMenu">
  <h4>
    {{currentMenu.title}}
  </h4>
</mat-nav-list>

<mat-nav-list class="secondary-menu-item" *ngFor="let menuItem of currentMenu?.subItems" >
  <a mat-button
     routerLink="{{menuItem.url}}" [queryParams]="menuItem.queryParams"
     routerLinkActive="{{menuItem.url == '/forbidden' ? 'not-active': 'active'}}"
     [class.deprecated]="menuItem.badge == 'deprecated'"
     [matTooltip]="getTooltipText(menuItem)" matTooltipPosition="after"
  >
    <mat-icon *ngIf="menuItem.iconClass == 'material-icons'"
              [matBadge]="menuItem.notificationBadge > 99 ? 99 : menuItem.notificationBadge"
              matBadgeOverlap="true"
              matBadgeColor="warn"
              [matBadgeHidden]="!menuItem.notificationBadge"
    >{{menuItem.iconClassCode}}</mat-icon>

    <mat-icon *ngIf="menuItem.iconClass != 'material-icons'"
              fontSet="fa" [fontIcon]="menuItem.iconClass.replace('fa ', '')"
              [matBadge]="menuItem.notificationBadge > 99 ? 99 : menuItem.notificationBadge"
              matBadgeOverlap="true"
              matBadgeColor="warn"
              [matBadgeHidden]="!menuItem.notificationBadge"
    >{{menuItem.iconClassCode}}</mat-icon>
    {{menuItem.title}}
    <button class="beta-button" mat-flat-button *ngIf="menuItem.badge == 'beta'">BETA</button>
  </a>

</mat-nav-list>
